import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { TradeStatusEnum } from "src/services/interfaces/TradeStatusEnum";
import { TradePhaseEnum } from "src/services/interfaces/trade/TradePhaseEnum";
import RedirectButton from "src/components/Refatoracao/RedirectButton/RedirectButton";
import ReloadComplianceButton from 'src/components/common/GenericButtons/ReloadBackgroundCheck/ReloadBackgroundCheck';
import { BcheckTypeEnum } from 'src/services/interfaces/UserInterface';
import ViewPendencyButton from 'src/components/common/GenericButtons/Pendency/ViewPendency/ViewPendencyButton';
import PreFraudButton from "src/components/common/PreFraudView/ViewPreFraudButton";
import WorkflowTradeList from "src/components/Refatoracao/TradeList/WorkflowTradeList";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { UploadDocumentButton } from "src/components/Refatoracao/UploadDocument/UploadDocumentButton";
import { DocumentCategoryEnum } from "src/components/Refatoracao/UploadDocument/DocumentCategoryEnum";
import { StorageTypeEnum } from "src/components/Refatoracao/UploadDocument/StorageTypeEnum";

interface IMyOperationPageProps extends RouteComponentProps<any> {
	trade?: ITrade;
}

export default function MyOperationsPage(props: IMyOperationPageProps) {
	const wfStatus = [TradeStatusEnum.Aberto, TradeStatusEnum.Pendencia];
	const wfPhases = [
		TradePhaseEnum.ContractInformation,
		TradePhaseEnum.LegalCertificates,
		TradePhaseEnum.DocumentValidation,
		TradePhaseEnum.DocumentApproval,
		TradePhaseEnum.Analysis,
		TradePhaseEnum.Diligence,
		TradePhaseEnum.LawyerCompliance,
		TradePhaseEnum.SpecialSituation,
		TradePhaseEnum.PreCartorio,
		TradePhaseEnum.DigitalCertificate,
		TradePhaseEnum.PreSpecialSituation,
		TradePhaseEnum.PreDisbursement,
		TradePhaseEnum.Cartorio,
		TradePhaseEnum.Funding,
		TradePhaseEnum.ContractSignature
	];

	const showPrivateDeed = [
		TradePhaseEnum.PreCartorio,
		TradePhaseEnum.Cartorio,
		TradePhaseEnum.PreDisbursement
	];

	const cardTitle = "Minhas Operações";

	const enablePhases = [TradePhaseEnum.Created, TradePhaseEnum.ContractInformation, TradePhaseEnum.LegalCertificates, TradePhaseEnum.DocumentValidation, TradePhaseEnum.DocumentApproval];


	return (
		<WorkflowTradeList listStatus={wfStatus} listPhase={wfPhases} cardTitle={cardTitle} isArchiveEnabled={true} showArchivedTrades={false}>
			<PreFraudButton />
			<RedirectButton icon="edit" buttonText="Editar" redirectWithTradeId={true} urlRedirect="/monitor/manual-trade/edit/" {...props} />
			<RedirectButton
				tooltipTitleDisabled="Trade bloqueado para edição devido sua fase atual"
				icon="edit"
				disabled={(trade) => !enablePhases.includes(trade.phase)}
				buttonText="Editar Precatório"
				urlRedirect="/monitor/precatorios/list/"
				redirectWithPrecatorioId
				{...props}
			/>
			<RedirectButton
				icon="eye"
				buttonText="Visualizar Operação"
				redirectWithTradeId={true}
				urlRedirect="/venda/"
				disabled={(trade) => trade.phase === TradePhaseEnum.PreDisbursement}
				{...props} />
			<UploadDocumentButton
				hoverText="Enviar instrumento de cessão particular"
				title="Instrumento de cessão particular"
				uploadCategory={DocumentCategoryEnum.PRIVATE_DEED}
				storageType={StorageTypeEnum.S3}
				hidenAsAChildren={(trade) => {
					return !showPrivateDeed.includes(trade.phase);
				}}
			/>
			<ReloadComplianceButton
				changePhase={false}
				bcheckType={BcheckTypeEnum.Credit}
				tooltipTitle="Validar cliente cadastrado"
				isNotBlue={true}
				disabled={(trade) => !enablePhases.includes(trade.phase)}
				approvedTooltipTitle="Validação de cliente aprovado"
			>
				Validação de cliente aprovado
			</ReloadComplianceButton>
			<ViewPendencyButton />
		</WorkflowTradeList>
	);
}



// WEBPACK FOOTER //
// ./src/pages/monitor/operacoes/trades/MyOperations.page.tsx